module.exports = __webpack_public_path__ + "img/2.bbdfa594.png";